export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ReferenciaBancariaPage.vue?vue&type=template&id=b54bfc98&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/pages/inscripciones/ReferenciaBancariaPage.vue?vue&type=template&id=b54bfc98&scoped=true&
// module id = 671
// module chunks = 14